import { IconVariant } from '@/components/icons/types';
import { MouseEvent } from 'react';

export enum HeaderButtonIdentifier {
  Profile = 'profile',
  Bookings = 'bookings',
  Favorites = 'favorites',
  LogIn = 'user_log_in',
  ConnectCompany = 'b2b',
  CompanyLogin = 'merchant',
  Back = 'back',
}

export type HeaderButton = {
  id?: string;
  icon?: IconVariant;
  label?: string;
  to?: string;
  className?: string;
  identifier: HeaderButtonIdentifier;
  breakpoint?: string;
};

export type HeaderButtonProps = {
  item: HeaderButton;
  isActive: boolean;
  onClick?: (event: MouseEvent<HTMLElement>) => void;
  onMouseDown?: () => void;
} & React.HTMLAttributes<HTMLButtonElement | HTMLAnchorElement>;
